import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import { locations } from "../locationData";

const featuredLocations = locations
  .filter((location) => location.service === "Taktvätt")
  .slice(0, 12);

export default function Coverage() {
  return (
    <section id="omraden" className="hpr-blue-tint py-16 lg:py-24">
      <div className="mx-auto max-w-4xl px-5 sm:px-6 text-center reveal">
        <p className="text-sm font-bold uppercase tracking-[0.15em] text-[#1B45C4]">Våra områden</p>
        <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold text-slate-900">Alltid nära.</h2>
        <p className="mt-4 mx-auto max-w-2xl text-slate-600 text-lg">
          Med egna team på plats i <strong className="text-slate-800">Stockholm & Uppsala</strong> finns vi där du är –
          oavsett om du bor i villa, förvaltar fastigheter eller sitter i en styrelse. Vi kapar
          väntetider och ger tydliga svar från första kontakt.
        </p>
        <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2.5">
          {featuredLocations.map((location) => (
            <Link
              key={location.slug}
              to={`/${location.slug}`}
              data-testid={`area-${location.slug}`}
              className="group flex items-center gap-2 rounded-xl bg-white px-3.5 py-2.5 ring-1 ring-slate-100 transition-all hover:ring-[#1B45C4]/40 hover:shadow-md"
            >
              <MapPin className="w-4 h-4 text-[#38BDF8] group-hover:text-[#1B45C4] transition-colors shrink-0" />
              <span className="text-sm font-medium text-slate-700 group-hover:text-[#1B45C4]">Taktvätt i {location.city}</span>
            </Link>
          ))}
        </div>
        <Button asChild className="mt-10 rounded-full h-13 px-7 py-3 bg-[#1B45C4] hover:bg-[#12308f] text-white font-semibold">
          <Link to="/taktvatt-stockholm" data-testid="coverage-cta">Se taktvätt i Stockholm <ArrowRight className="ml-2 w-5 h-5" /></Link>
        </Button>
      </div>
    </section>
  );
}
